
<component
  :is="as"
  :class="['pill', { active, readonly, 'no-margin': noMargin, sortable, empty }]"
  v-tooltip="{ content: tooltip, delay: { show: 1000, hide: 100 }, placement: 'bottom' }"
  v-bind="$attrs"
  v-on="$listeners"
>
  <span>
    <slot />
  </span>

  <icon v-if="sortable" name="arrow_drop_down" class="icon" />
</component>
